import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters } = Filters;

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const StatusFilter = {
  ...BaseFilters.EnumFilter,
  name: 'status',
  label: 'applications.text.teamsMessage.status',
  enumNamespace: getEnumNamespace(CoreEnums.MessageStatus, 'Status'),
  enumSource: CoreEnums.MessageStatus,
  options: createEnumOptions(CoreEnums.MessageStatus, 'applications.text.teamsMessageStatus'),
};

const DeliveryProviderFilter = {
  ...BaseFilters.EnumFilter,
  name: 'deliveryProvider',
  label: 'applications.text.smsMessage.deliveryProvider',
  enumNamespace: getEnumNamespace(CoreEnums.SmsDeliveryProvider, 'SMS'),
  enumSource: CoreEnums.SmsDeliveryProvider,
  options: createEnumOptions(CoreEnums.SmsDeliveryProvider, 'global.smsDeliveryProvider', {
    casing: 'camel',
  }),
};

const AgentFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'agentId',
  label: 'applications.text.teamsMessage.agent',
  apiRoute: 'ai/agent/manageable',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

export const filtersConfig = [CreatedDateFilter, StatusFilter, DeliveryProviderFilter, AgentFilter];

registerModuleFilters('smsMessageTrace', filtersConfig);
